/* eslint-disable */
import Vue from 'vue'

/**
 * 统计应用配置设置
 * @param {*} params
 */
 export const updateAppOnCompanyTab = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/updateAppConfigOnTab', params)
}
/**
 * 统计应用配置总数
 * @param {*} params
 */
export const countAppInfoConfig = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/countAppInfoConfig', params)
}

/**
 * 获取应用消息订阅设置详情
 * @param {*} params
 */
export const getAppRule = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/getEventRule', params)
}
/**
 * 消息订阅设置
 * @param {*} params
 */
export const setAppRule = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/saveOrUpdateRule', params)
}

/**
 * 更新应用功能分到账号
 * @param {*} params
 */
export const updateAppConfigAccount = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/updateAppConfig', params)
}
/**
 * 应用功能分到账号
 * @param {*} params
 */
export const getAppConfigAccountList = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/queryAppConfig', params)
}

/**
 * 应用变更邮箱
 * @param {*} params
 */
export const updateAppEmail = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/updateAppBindEmailAndPhone', params)
}

export const sendParams = params => {
  return Vue.fetch.post('/apiv1/push/param/openOrClose', params)
}

/**
 * 查看AppSecret
 * @param {*} params
 */
export const getAppSecret = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/getAppSecret', params)
}
/**
 * 获取参数配置
 * @param {*}} params
 */
export const getParams = params => {
  return Vue.fetch.post('/apiv1/push/param/findList', params)
}

/**
 * 推送错误信息
 * @param {*}} params
 */
export const getErrorMsg = params => {
  return Vue.fetch.post('/apiv1/data/relay/getPushRecords', params)
}

/**
 * 删除配置
 * @param {*}} params
 */
export const deleteConfig = params => {
  return Vue.fetch.post('/apiv1/push/type/deletePushType', params)
}

/**
 * 更新配置
 * @param {*}} params
 */
export const updateConfigType = params => {
  return Vue.fetch.post('/apiv1/push/type/update', params)
}

/**
 * 获取配置类型
 * @param {*}} params
 */
export const getConfigType = params => {
  return Vue.fetch.post('/apiv1/push/type/typeList', params)
}

/**
 * 获取配置列表
 * @param {*}} params
 */
export const getConfigList = params => {
  return Vue.fetch.post('/apiv1/push/type/findPage', params)
}

/**
 * 添加配置
 * @param {*}} params
 */
export const addConfig = params => {
  return Vue.fetch.post('/apiv1/push/type/save', params)
}

/**
 * 获取队列
 * @param {*}} params
 */
export const getQueueLists = () => {
  return Vue.fetch.post('/apiv1/data/queue/getQueueList')
}
/**
 * 上传图片
 * @param {*}} params
 */
export const uploadAvter = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/uploadAppIcon', params)
}
/**
 * 销毁应用
 * @param {*} params
 */
export const destroyApp = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/destroyApp', params)
}
/**
 * 撤销应用
 * @param {*} params
 */
export const withdrawApp = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/recallApp', params)
}
/**
 *  应用回收站列表
 * @param {*} params
 */
export const recycleList = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/appRecycle', params)
}
/**
 * 删除应用
 * @param {*} params
 */
export const deleteApp = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/deleteApp', params)
}
/**
 * 校验验证码
 * @param {*} params
 */
export const checkVrificationCode = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/checkVerifyCode', params)
}
/**
 * 删除应用发送验证码
 * @param {*} params
 */
export const sendVerifyCode = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/sendVerifyCode', params)
}

export const getAppList = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/findAppInfoList', params)
}

export const saveOrUpdateApp = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/saveOrUpdate', params)
}

export const findSettingDetail = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/findSettingDetail', params)
}

export const saveOrUpdateSetting = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/saveOrUpdateSetting', params)
}

export const reCreatAppSecret = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/reCreatAppSecret', params)
}

export const testUrl = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/testUrl', params)
}

export const findAppInfoDetail = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/findAppInfoDetail', params)
}

export const pageIndex = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/pageIndex', params)
}



// WEBPACK FOOTER //
// ./src/services/appManagerApi.js